exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main.container {\n  padding-top: 400px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main